import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserProfileService, MenuItem } from 'src/app/modules/usermanagement/services/user-profile.service';

@Component({
  selector: 'app-navbar',
  standalone: false,
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {
  activeRoute: string = '';
  visibleMenuItems: MenuItem[] = [];

  constructor(
    private router: Router,
    public userProfileService: UserProfileService
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.activeRoute = (event as NavigationEnd).url;
      });
  }

  ngOnInit() {
    this.activeRoute = this.router.url;
    this.loadVisibleMenuItems();

    // Subscribe to user profile changes to refresh menu items
    this.userProfileService.userProfile$.subscribe(() => {
      this.loadVisibleMenuItems();
    });
  }

  loadVisibleMenuItems(): void {
    this.visibleMenuItems = this.userProfileService.getVisibleMenuItems();
  }

  isActive(route: string): boolean {
    if (route === '/' && this.activeRoute === '/') {
      return true;
    }

    // Special handling for devices route
    // Only activate side menu when on /devices (DevicesComponent)
    if (route === '/devices') {
      return this.activeRoute === '/devices' || this.activeRoute === '/devices/';
    }

    if (route === '/customers') {
      return this.activeRoute === '/customers' || this.activeRoute === '/customers/';
    }

    if (route === '/locations') {
      return this.activeRoute === '/locations' || this.activeRoute === '/locations/';
    }

    if (route !== '/' && this.activeRoute.startsWith(route)) {
      return true;
    }
    return false;
  }

}
